import { render } from "./NewsTop.vue?vue&type=template&id=21b11dba&scoped=true"
import script from "./NewsTop.vue?vue&type=script&lang=ts"
export * from "./NewsTop.vue?vue&type=script&lang=ts"

import "./NewsTop.vue?vue&type=style&index=0&id=21b11dba&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-21b11dba"

export default script